webpackJsonp([7],{

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_autobind_decorator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_autobind_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mobx_react__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__widgets__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Home_less__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Home_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Home_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_floorModule_floorTitle__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__operates__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mobx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_network__ = __webpack_require__(79);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};











// 暂时注释，不可删除




/**
 * 1、首页容器组件
 */
var Home = /** @class */ (function (_super) {
    __extends(Home, _super);
    function Home(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.refMap = {
            oneScroll: function (any) { return _this.oneScroll = any; },
            rankView: function (obj) { return _this.setState({
                rankView: obj
            }); },
            searchNode: function (obj) { return _this.searchNode = obj; },
        };
        _this.window = window;
        _this.oneScroll = __WEBPACK_IMPORTED_MODULE_5__components__["g" /* OneScroll */];
        _this.searchNode = __WEBPACK_IMPORTED_MODULE_6__widgets__["E" /* SearchComp */];
        _this.rankDetail = __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]; // 详情数据
        _this.skoData = __WEBPACK_IMPORTED_MODULE_7__model__["w" /* SkoList */];
        _this.getTipLayerData = __WEBPACK_IMPORTED_MODULE_7__model__["k" /* GetTipLayer */];
        _this.tipLayerData = '';
        _this.selectSkuId = ''; // 选中的skuID
        _this.skoDataObj = {}; // 选中的skuID
        _this.tabArrList = []; // 频道列表
        _this.quickEnter = new __WEBPACK_IMPORTED_MODULE_7__model__["n" /* Logistics */]({ url: 'home/v1/quickEnter' }); // 快捷入口
        _this.timeAxisList = {};
        _this.timeCurrent = 0;
        _this.goodsList = [];
        _this.isFixedRender = true;
        _this.timeThemeList = [];
        _this.getBackground = function () {
            Object(__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* get */])("regions/v1/getBgImgByType?type=1").then(function (res) {
                if (res.errCode == 200) {
                    var data = res.data;
                    _this.setState({
                        bgType: data.bgType,
                        searchValue: data.searchValue,
                        bannerValue: data.bannerValue,
                        bgValue: data.bgValue,
                    });
                }
            });
        };
        _this.state = {
            rankView: undefined,
            isTop: false,
            homey: 0,
            isFixed: false,
            productId: '',
            isShow: false,
            downHight: 0,
            saveY: 0,
            isShowHome: false,
            isShowHomeSheel: false,
            process_bar_width: 0,
            isLoaded: false,
            GetTimerShaftData: '',
            shaftType: 1,
            needFixed: false,
            timeFixed: false,
            timeFixedFirst: false,
            navKey: (Math.random()).toString(),
            bgType: "",
            searchValue: "",
            bannerValue: "",
            bgValue: "",
            firstInit: true
        };
        return _this;
    }
    Home.prototype.componentWillMount = function () {
        var _this = this;
        var init_url = window.location.href;
        var user_agent = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(user_agent)) {
            if (init_url.includes('?#!') && !init_url.includes('&share')) {
                init_url = init_url.split('?#!');
                init_url = init_url[0] + '#!' + init_url[1];
            }
        }
        if (init_url) {
            sessionStorage.setItem('init_url', init_url);
        }
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isGameAppdetail = false;
        document.title = '国孕商城';
        var channelState = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.channelState;
        var isRequest = channelState == 'initial' ? true : false;
        if (Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])("isIosApp") !== "") {
            sessionStorage.setItem("isIosApp", "1");
            sessionStorage.setItem("iosCBUrl", Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])("isIosApp")); // ios App微信支付回调地址
        }
        if (window.homey) {
            this.setState({
                homey: window.homey
            });
        }
        if (!window.homeList || isRequest) {
            window.homeList = new __WEBPACK_IMPORTED_MODULE_7__model__["r" /* RankList */]({ url: 'newproduct/v1/list' }); // 精选好货
        }
        if (!window.bannerList || isRequest) {
            window.bannerList = new __WEBPACK_IMPORTED_MODULE_7__model__["p" /* NoPaginationList */]({ url: 'regions/v1/bannerList' }); // 轮播
            window.bannerList.fetch();
        }
        if (!window.floorList || isRequest) {
            window.floorList = new __WEBPACK_IMPORTED_MODULE_7__model__["g" /* FloorList */]({ url: 'floor/v1/floorList' }); // 轮播下边精选好货上边
            window.floorList.fetch();
        }
        this.tabArrList = new __WEBPACK_IMPORTED_MODULE_7__model__["g" /* FloorList */]({ url: 'regions/v1/getClassInfo', level: 1, classType: 1 }); //轮播上边tab
        this.tabArrList.fetch(function (data) {
            _this.setState({
                isShowHome: true
            });
            var channelState = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.channelState;
            for (var i = 0; i < data.length; i++) {
                if (data[i].id == channelState || channelState == 'channel') {
                    return;
                }
            }
            channelState && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.setChannelSate('initial');
            channelState && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.setInitialSlide(0);
        });
        this.getTipLayerData = new __WEBPACK_IMPORTED_MODULE_7__model__["k" /* GetTipLayer */]({ url: 'home/v1/getTipLayer' });
        var that = this;
        that.getTipLayerData.fetch(function (data) {
            that.tipLayerData = data;
            if (that.tipLayerData == '' || that.tipLayerData == null || that.tipLayerData.tipImg == null) {
                that.setState({
                    isShowHomeSheel: false,
                });
            }
            else {
                that.setState({
                    isShowHomeSheel: true,
                });
            }
            return data;
        });
        if (Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])('type')) {
            this.getTimerShaft = new __WEBPACK_IMPORTED_MODULE_7__model__["j" /* GetTimerShaft */]({
                url: 'newproduct/v1/list/getShareTimerShaft',
                type: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])('type'),
                date: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])('date'),
                shaftId: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])('shaftId')
            });
        }
        else {
            this.getTimerShaft = new __WEBPACK_IMPORTED_MODULE_7__model__["j" /* GetTimerShaft */]({ url: 'newproduct/v1/list/getTimerShaft', type: 0 });
        }
        this.getTimerShaft.fetch(function (data) {
            _this.timeAxisList = data;
            for (var i = 0; i < _this.timeAxisList.navigat.length; i++) {
                if (_this.timeAxisList.navigat[i].center == 1) {
                    _this.timeCurrent = i;
                    sessionStorage.setItem('timeCurrent', _this.timeCurrent);
                    return;
                }
            }
        });
        this.getBackground();
        //获取微信签名
        this.getSignature();
    };
    Home.prototype.componentDidMount = function () {
        var that = this;
        var deviceWidth = document.documentElement.clientWidth;
        // if (deviceWidth >= 1080) { deviceWidth = 1080; }
        document.documentElement.style.fontSize = deviceWidth / 38 + "px";
        that.setState({
            isLoaded: true
        });
        // 快捷入口
        this.quickEnter.fetch();
        __WEBPACK_IMPORTED_MODULE_9__utils__["w" /* tingYun */].setTingYun('home');
        // burialPoint('burialpoint/logIndexAndSubject', {body: JSON.stringify(this._setBurialPoint())});
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.appTitle = '国孕商城';
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowLeftBackBtn = false;
        __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.rightBtnType = 'backHall';
        // 首席看护人免登录开始
        var token = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])("token");
        var mobile = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])("mobile");
        var isCaretaker = Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])("isCaretaker");
        if (isCaretaker !== "") {
            sessionStorage.setItem("isCaretaker", isCaretaker);
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("mobile", mobile);
            Object(__WEBPACK_IMPORTED_MODULE_9__utils__["h" /* get */])("user/v2/mobile/login/web/NoSecret?mobile=" + mobile + "&isCaretaker=" + isCaretaker + "&token=" + token).then(function (res) {
                if (res.data != null && res.errCode == 200) {
                    Object(__WEBPACK_IMPORTED_MODULE_14__utils_network__["j" /* setCookie */])("pub-token", res.data.token, 3);
                }
            });
        }
        // 首席看护人免登录结束
    };
    ;
    Home.prototype.getSignature = function () {
        return __awaiter(this, void 0, void 0, function () {
            var name, avatar, shareUrl, user_agent, shareInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        name = (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].user.shopInfo && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].user.shopInfo.name) ? __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].user.shopInfo.name : '国孕商城';
                        avatar = (__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].user.shopInfo && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].user.shopInfo.avatar) ? __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].user.shopInfo.avatar : 'https://static.gjyunying.com/upload/share/share.png';
                        shareUrl = sessionStorage.getItem("init_url") //window.location.href.split('?#!')[0]
                        ;
                        user_agent = navigator.userAgent.toLowerCase();
                        if (/iphone|ipad|ipod/.test(user_agent)) {
                            avatar = decodeURIComponent(avatar);
                        }
                        shareInfo = {
                            shareTitle: '推荐给您一个不错的店铺: ' + name,
                            shareDesc: '欢迎光临小店',
                            shareUrl: shareUrl,
                            sharePic: avatar
                        };
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_12__operates__["i" /* getWXSignature */])(shareInfo.shareTitle, shareInfo.shareDesc, shareInfo.shareUrl, shareInfo.sharePic)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* 首页埋点 */
    Home.prototype._setBurialPoint = function (data) {
        var headerObj = data ? {
            user: {
                userType: 1,
                serviceType: 'C',
                osTypeId: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* _equipmentType */])(),
            },
            actionType: 4,
            clickInfo: {
                type: data.type,
                bannerId: data.bannerId,
                picUrl: data.picUrl
            }
        } : {
            user: {
                userType: 1,
                serviceType: 'C',
                osTypeId: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* _equipmentType */])(),
            },
            page: {
                pageId: 'index',
                originPageId: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["l" /* getUrlParam */])('originPageId') || '',
            }
        };
        return headerObj;
    };
    Home.prototype.onHomey = function (name) {
        this.setState({
            homey: name
        });
        window.homey = name;
    };
    //关闭及点击首页弹层调用的接口
    Home.prototype.clickCloseAlert = function (id) {
        new __WEBPACK_IMPORTED_MODULE_7__model__["e" /* DecrementCount */]({ tipId: id, url: 'home/v1/decrementCount' }).fetch(function (data) {
        });
    };
    // 首页快捷入口点击事件
    Home.prototype.onEntryClick = function (item) {
        var _this = this;
        if (item.type === 0) {
            // 查询productId
            new __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]({ skuCode: item.content, url: 'newproduct/v1/getProSkuId' }).fetch(null, function (data) {
                sessionStorage.setItem('__skuId', data.skuId);
                Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/appdetail/" + data.productId + "?originPageId=index&originType=3", _this);
            });
        }
        else if (item.type === 1) {
            location.href = item.content + "?originPageId=index";
        }
    };
    Home.prototype.renderContent = function () {
        var _this = this;
        var status = this.props.status;
        var homeSkin = status && status.getHomeSkin;
        var channelState = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.channelState;
        var isShowFloor = channelState && channelState != 'channel' && channelState != 'initial' ? false : true;
        var bgData = homeSkin[0] ? homeSkin[0].pageVO : {};
        var bgStyle = {};
        if (bgData) {
            bgStyle = {
                floorGapColour: bgData.floorGapColour,
            };
        }
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            window.bannerList.list.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["d" /* Banner */], { style: {
                        background: this.state.bgType === 1 ? this.state.bannerValue : "url(" + this.state.bannerValue + ") 0% 0% / 100% 100% no-repeat",
                    }, bannerList: window.bannerList.list, onClick: this.onBannerClick, isRecommend: isShowFloor }),
            isShowFloor && this.quickEnter.logisticsData && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["H" /* ShortcutEntry */], { onEntryClick: this.onEntryClick, data: this.quickEnter.logisticsData || [], bgData: bgData })),
            isShowFloor && window.floorList.list && window.floorList.list.length > 0 && window.floorList.list.map(function (item) {
                return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["n" /* FloorModule */], { floorItem: item, key: item.id, onFloorClick: _this.onFloorClick, bgData: bgData }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "floorModule-space", style: bgData ? { background: bgStyle.floorGapColour } : {} })));
            }),
            isShowFloor && (this.timeAxisList.navigat && this.timeAxisList.navigat.length > 0) && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: 'isFix' },
                !this.state.timeFixed ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["P" /* TimeAxis */], { navigat: this.timeAxisList && this.timeAxisList.navigat, onClick: this.onTimeAxisClick, currentIndex: this.timeCurrent, timeFixed: this.state.timeFixed, transformClass: 'swiper-container-other-timer' })
                    : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { height: '6.6rem' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["R" /* TimeMainGoods */], { goodsList: this.timeAxisList && this.timeAxisList.timer, onAddShop: this.onAddShop, toAppDetail: this.toApptaile, onSpecialClick: this.onSpecialClick, type: this.state.shaftType }))),
            isShowFloor && window.floorList.list && window.floorList.list.length > 0 &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginTop: '.8rem' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__widgets_floorModule_floorTitle__["a" /* FloorTitle */], { floorName: '精选好货' }))));
    };
    // 时间轴切换
    Home.prototype.onTimeAxisClick = function (item, index) {
        var _this = this;
        this.timeCurrent = index;
        this.setState({
            shaftType: item.type
        });
        var obj = { url: 'newproduct/v1/list/getTimerShaft', type: item.type };
        item.type === 0 && Object.assign(obj, { shaftId: item.shaftId });
        this.htmlId = item.shaftId ? item.shaftId : '';
        this.getTimerShaft = new __WEBPACK_IMPORTED_MODULE_7__model__["j" /* GetTimerShaft */](obj);
        this.getTimerShaft.fetch(function (data) {
            _this.timeAxisList = data;
        });
    };
    // 跳转至专题
    Home.prototype.onSpecialClick = function (data) {
        location.href = data + "?originPageId=index";
    };
    // 时间轴商品加入购物车
    Home.prototype.onAddShop = function (data) {
        var obj = {
            data: data.skuId,
            selectNumber: 1
        };
        if (Object(__WEBPACK_IMPORTED_MODULE_14__utils_network__["e" /* getCookie */])("pub-token") === "") {
            sessionStorage.setItem("addShopData", JSON.stringify(obj));
            sessionStorage.setItem('oldPage', "home");
            Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/loginPage/addShop?originPageId=home", this);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_12__operates__["a" /* addShop */])(obj, this.props.user, function (isRun) {
                if (isRun)
                    return;
                var skuIdStr = sessionStorage.getItem('__shop');
                if (skuIdStr) {
                    skuIdStr.indexOf(data.skuId) == -1 && sessionStorage.setItem('__shop', skuIdStr + ',' + data.skuId);
                }
                else {
                    sessionStorage.setItem('__shop', data.skuId);
                }
            });
        }
        this.setState({
            navKey: (Math.random()).toString()
        });
        // burialPoint('burialpoint/logShopCar', {
        //     body: JSON.stringify(this._transformBurialPointData({
        //         skuId: obj.data,
        //         productPrice: data.price,
        //         pageProductId: data.productId
        //     }))
        // });
    };
    Home.prototype.onBannerClick = function (item) {
        var that = this;
        if (item.bannerType == 2) {
            location.href = item.productSku + "?originPageId=index";
        }
        else {
            new __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]({ skuCode: item.productSku, url: 'newproduct/v1/getProSkuId' }).fetch(null, function (data) {
                sessionStorage.setItem('__skuId', data.skuId);
                // burialPoint('burialpoint/logBannerAndFloor', {
                //     body: JSON.stringify(that._setBurialPoint({
                //         type: 1,
                //         bannerId: data.banner_id,
                //         picUrl: data.imgUrl
                //     }))
                // });
                sessionStorage.setItem('isApp', 'false');
                Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/appdetail/" + data.productId + "?originPageId=index&originType=3", that);
            });
        }
    };
    /* 首页埋点 */
    Home.prototype._setFloorBurialPoint = function (id, picUrl) {
        var floorObj = {
            user: {
                userType: 1,
                serviceType: 'C',
                clientType: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.gameApp ? 3 : 4,
                osTypeId: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* _equipmentType */])(),
                appId: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.gameId ? __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.gameId : ''
            },
            actionType: 6,
            clickInfo: {
                type: 2,
                floorId: id,
                picUrl: picUrl
            }
        };
        return floorObj;
    };
    Home.prototype.onFloorClick = function (floorId, floorImgUrl, moduleType, moduleUrl) {
        var that = this;
        // burialPoint('burialpoint/logBannerAndFloor', {body: JSON.stringify(that._setFloorBurialPoint(floorId, floorImgUrl))});
        if (moduleType === 1) {
            // 根据sku编码获取商品id和skuid接口
            new __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]({ skuCode: moduleUrl, url: 'newproduct/v1/getProSkuId' }).fetch('floor', function (data) {
                sessionStorage.setItem('__skuId', data.skuId);
                Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/appdetail/" + data.productId, that);
            });
        }
        else if (moduleType === 2) {
            // 去专题页面moduleUrl
            location.href = moduleUrl + "?originPageId=index";
        }
    };
    Home.prototype.onChannelClick = function (item) {
        var _this = this;
        var channelState = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.channelState;
        var isShowFloor = channelState && channelState != 'channel' && channelState != 'initial' ? false : true;
        if (item) {
            var id = item.id;
            var uuidId = item.uuidId;
            window.homeList = new __WEBPACK_IMPORTED_MODULE_7__model__["r" /* RankList */]({
                url: 'searchapi/category/' + 1 + '/' + uuidId,
                type: 1,
                categoryId: uuidId
            });
            window.bannerList = new __WEBPACK_IMPORTED_MODULE_7__model__["p" /* NoPaginationList */]({ url: 'regions/v1/bannerList', channel: id });
            window.bannerList.fetch();
            var domNode_1 = document.getElementById('oneScroll_unMount');
            __WEBPACK_IMPORTED_MODULE_1_react_dom__["unmountComponentAtNode"](domNode_1);
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["g" /* OneScroll */], { style: _this.tabArrList.list.length > 0 ?
                        {
                            background: '#FFF',
                            top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? (isShowFloor ? '9rem' : '6rem') : (isShowFloor ? '8.8rem' : '8.8rem')
                        } :
                        {
                            background: '#FFF',
                            top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? (isShowFloor ? '9rem' : '7rem') : (isShowFloor ? '0' : '5rem')
                        }, ref: _this.refMap.oneScroll, renderContent: _this.renderContent, fetchable: window.homeList, freeHeight: 5 + 'rem', renderItem: _this.renderItem, myY: 0, onHomey: _this.onHomey, showLoading: _this.showLoading, isToTop: true, onScroll: _this.onScroll, bgValue: _this.state.bgType }), domNode_1);
            }, 0);
        }
        else if (!item) {
            window.homeList = new __WEBPACK_IMPORTED_MODULE_7__model__["r" /* RankList */]({ url: 'newproduct/v1/list' });
            window.bannerList = new __WEBPACK_IMPORTED_MODULE_7__model__["p" /* NoPaginationList */]({ url: 'regions/v1/bannerList', channel: '-1' });
            window.bannerList.fetch();
            var domNode_2 = document.getElementById('oneScroll_unMount');
            __WEBPACK_IMPORTED_MODULE_1_react_dom__["unmountComponentAtNode"](domNode_2);
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_1_react_dom__["render"](__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["g" /* OneScroll */], { style: _this.tabArrList.list.length > 0 ?
                        {
                            background: '#FFF',
                            top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? (isShowFloor ? '9rem' : '6rem') : (isShowFloor ? '8.8rem' : '8.8rem')
                        } :
                        {
                            background: '#FFF',
                            top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? (isShowFloor ? '9rem' : '7rem') : (isShowFloor ? '0' : '5rem')
                        }, ref: _this.refMap.oneScroll, renderContent: _this.renderContent, fetchable: window.homeList, freeHeight: 5 + 'rem', renderItem: _this.renderItem, myY: 0, onHomey: _this.onHomey, showLoading: _this.showLoading, isToTop: true, onScroll: _this.onScroll }), domNode_2);
            }, 0);
        }
        this.forceUpdate();
    };
    Home.prototype.renderItem = function (data, index) {
        var _this = this;
        return data && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["c" /* AppList */], { data: data, key: index, shopHomeJia: function (data) {
                _this.shopHomeJia(data);
            }, toApptaile: this.toApptaile, date: data.skuItems[0].promotStatus === 1 ? (data.skuItems[0].startTime || 0) : (data.skuItems[0].endTime || 0), promotStatus: data.skuItems[0].promotStatus, type: data.skuItems[0].type }));
    };
    Home.prototype.toApptaile = function (productId) {
        if (sessionStorage.getItem('__selectSkuId')) {
            sessionStorage.removeItem('__selectSkuId');
        }
        if (sessionStorage.getItem('__selPropInfo')) {
            sessionStorage.removeItem('__selPropInfo');
        }
        Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])('/appdetail/' + productId + '?' + Object(__WEBPACK_IMPORTED_MODULE_9__utils__["n" /* params2QueryString */])({ originType: 3, originPageId: 'index' }, {}), this);
    };
    Home.prototype.onScroll = function (y) {
        var that = this;
        if (window.document.getElementById('isFix')) {
            var fixedTop = window.document.getElementById('isFix').offsetTop;
            var fixedHeight = window.document.getElementById('isFix').clientHeight;
            if (y > (fixedTop) && y < (fixedTop + fixedHeight)) {
                that.setState({
                    timeFixed: true,
                });
                this.isFixedRender = true;
            }
            if (y < (fixedTop)) {
                that.setState({
                    timeFixed: false,
                });
            }
            if (y > (fixedTop + fixedHeight - 100) && this.isFixedRender) {
                that.setState({
                    timeFixed: false
                });
                this.isFixedRender = false;
            }
        }
    };
    Home.prototype.shopHomeJia = function (data) {
        this.shopHomeJiaFunc(data);
    };
    // 加入购物车逻辑处理
    Home.prototype.shopHomeJiaFunc = function (data) {
        // let that = this;
        if (data.specifications === 1) {
            var obj = {
                data: data.skuItems[0].skuId,
                selectNumber: 1
            };
            if (Object(__WEBPACK_IMPORTED_MODULE_14__utils_network__["e" /* getCookie */])("pub-token") === "") {
                sessionStorage.setItem("addShopData", JSON.stringify(obj));
                Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/loginPage/addShop?originPage=home", this);
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_12__operates__["a" /* addShop */])(obj, this.props.user, function (isRun) {
                    if (isRun)
                        return;
                    var skuIdStr = sessionStorage.getItem('__shop');
                    if (skuIdStr) {
                        skuIdStr.indexOf(data.skuItems[0].skuId) == -1 && sessionStorage.setItem('__shop', skuIdStr + ',' + data.skuItems[0].skuId);
                    }
                    else {
                        sessionStorage.setItem('__shop', data.skuItems[0].skuId);
                    }
                });
            }
            // burialPoint('burialpoint/logShopCar', {
            //     body: JSON.stringify(that._transformBurialPointData({
            //         skuId: obj.data,
            //         productPrice: data.minPrice,
            //         pageProductId: data.productId
            //     }))
            // });
        }
        else {
            var that_1 = this;
            var d_1 = data;
            this.setState({
                productId: d_1.productId
            });
            this.rankDetail = new __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]({
                url: 'newproduct/v1/detail',
                productId: d_1.productId,
                partnerId: that_1.props.user.partnerId
            });
            that_1.rankDetail.fetch(null, function (data) {
                if (data.productInfo.specifications === 1) {
                    that_1.selectSkuId = data.productInfo.skuItems[0].skuId;
                }
                else {
                    that_1.skoData = new __WEBPACK_IMPORTED_MODULE_7__model__["w" /* SkoList */]({ url: 'newproduct/v1/sku/selector', productId: d_1.productId });
                    that_1.skoData.fetch(function (data) {
                        that_1.skoDataObj = data;
                        that_1.setState({
                            isShow: true,
                        });
                        return data;
                    });
                }
            });
        }
        this.setState({
            navKey: (Math.random()).toString()
        });
    };
    Home.prototype._transformBurialPointData = function (obj) {
        if (obj === void 0) { obj = {}; }
        var newObj = {
            user: {
                userType: 1,
                serviceType: 'C',
                clientType: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.gameApp ? 3 : 4,
                osTypeId: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* _equipmentType */])(),
            },
            page: {
                pageId: 'product',
                originPageId: '',
            },
            product: {
                pageProductId: obj.pageProductId,
                originType: 3,
                addShopCart: 2,
                skuId: obj.skuId,
                productPrice: obj.productPrice,
            }
        };
        return newObj;
    };
    Home.prototype.hideHomeJia = function (navKey) {
        if (navKey === void 0) { navKey = (Math.random()).toString(); }
        this.setState({
            isShow: false,
            navKey: navKey,
        }, function () { });
    };
    Home.prototype.toOther = function (url) {
        var _this = this;
        if (this.tipLayerData.content.indexOf('http') == -1 && !__WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.gameApp) {
            new __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]({ skuCode: this.tipLayerData.content, url: 'newproduct/v1/getProSkuId' }).fetch(null, function (data) {
                Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/appdetail/" + data.productId + "?originPageId=index&originType=3", _this);
            });
        }
        else if (this.tipLayerData.content.indexOf('http') == -1 && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.gameApp) {
            new __WEBPACK_IMPORTED_MODULE_7__model__["q" /* RankDetail */]({ skuCode: this.tipLayerData.content, url: 'newproduct/v1/getProSkuId' }).fetch(null, function (data) {
                Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])("/appdetail/" + data.productId + "?originPageId=index&originType=3&gameApp=true", _this);
            });
        }
        else {
            window.location.href = url;
        }
        this.clickCloseAlert(this.tipLayerData.id);
    };
    Home.prototype.clickMethods = function () {
        if (this.state.isShowHomeSheel) {
            this.setState({
                isShowHomeSheel: false,
            });
            this.clickCloseAlert(this.tipLayerData.id);
        }
    };
    // 跳转搜索页
    Home.prototype.onSearchClick = function () {
        if (localStorage.searchStartKey) {
            localStorage.removeItem('searchStartKey');
        }
        Object(__WEBPACK_IMPORTED_MODULE_9__utils__["q" /* push */])('/searchStart', this);
    };
    Home.prototype.showLoading = function () {
        // 下拉刷新重新调用banner接口
        window.bannerList.fetch();
        window.floorList.fetch();
    };
    Home.prototype.render = function () {
        var _this = this;
        var prefixCls = this.props.prefixCls;
        var isShowHome = this.state.isShowHome;
        var channelState = __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].classification.channelState;
        var isShowFloor = channelState && channelState != 'channel' && channelState != 'initial' ? false : true;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: {
                    display: this.state.isLoaded ? 'block' : 'none',
                    paddingTop: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? '5.7rem' : ''
                } },
                isShowHome ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-topBox clearfix", style: {
                                top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? '5rem' : '',
                                background: this.state.bgType === 1 ? this.state.searchValue : "url(" + this.state.searchValue + ") 0% 0% / 100% 100% no-repeat",
                                backgroundSize: '100% 100%'
                            } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["E" /* SearchComp */], { ref: 'searchNode', onClick: function () {
                                    _this.onSearchClick();
                                }, data: this.props.user ? this.props.user.shopInfo : {} })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "" + prefixCls, style: { position: 'relative', top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? '5.1rem' : '4.7rem', paddingLeft: 0, paddingRight: 0 } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-floor clearfix", style: {
                                    top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? '5rem' : '',
                                    background: this.state.bgType === 1 ? this.state.searchValue : "url(" + this.state.searchValue + ") 0% 0% / 100% 100% no-repeat",
                                    backgroundSize: '100% 100%'
                                } },
                                this.tabArrList.list && this.tabArrList.list.length > 0 &&
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["e" /* Channel */]
                                    // style={{ background: this.state.bgType === 1 ? this.state.bannerValue : `url(${this.state.bannerValue})` }}
                                    , { 
                                        // style={{ background: this.state.bgType === 1 ? this.state.bannerValue : `url(${this.state.bannerValue})` }}
                                        tabArrList: this.tabArrList.list, onChannelClick: this.onChannelClick, isShowFloor: isShowFloor }),
                                this.state.timeFixed &&
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["P" /* TimeAxis */], { navigat: this.timeAxisList && this.timeAxisList.navigat, onClick: this.onTimeAxisClick, currentIndex: this.timeCurrent, timeFixed: this.state.timeFixed, transformClass: 'swiper-container-other-timer2' })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { id: 'oneScroll_unMount' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["g" /* OneScroll */], { style: this.tabArrList.list.length > 0 ?
                                        {
                                            background: this.state.bgValue,
                                            backgroundSize: '15rem',
                                            top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? (isShowFloor ? '9rem' : '6rem') : (isShowFloor ? '8.8rem' : '8.8rem'),
                                        } :
                                        {
                                            background: this.state.bgValue,
                                            backgroundSize: '15rem',
                                            top: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].status.isShowHead ? (isShowFloor ? '9rem' : '7rem') : (isShowFloor ? '3.7rem' : '3.7rem'),
                                        }, ref: 'onScroll', renderContent: this.renderContent, fetchable: window.homeList, freeHeight: 5 + 'rem', renderItem: this.renderItem, myY: this.state.homey, onHomey: this.onHomey, showLoading: this.showLoading, isToTop: true, onScroll: this.onScroll }))))
                    :
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: prefixCls + "-loading" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["q" /* Nav */], { key: this.state.navKey }),
                this.state.isShow ?
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__widgets__["K" /* SkuSelectComp */], { user: this.props.user, productId: this.state.productId, hideHomeJia: function () {
                            _this.hideHomeJia();
                        }, isShow: this.state.isShow, selectSkuId: this.selectSkuId, skoData: this.skoDataObj, rankDetail: this.rankDetail, pageId: 'index' })
                    : null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'loading1', style: { display: this.state.isLoaded ? 'none' : 'block' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'process_view' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'process_bar', style: { width: this.state.process_bar_width + 'rem' } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'process_text' }, "\u66F4\u65B0\u4E2D\u8BF7\u7A0D\u540E")),
            this.state.isShowHomeSheel &&
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'homeShells' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: 'homeShells-area-container' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: this.tipLayerData.tipImg, className: 'homeShells-img-area', onClick: function () {
                            _this.toOther(_this.tipLayerData.content);
                        }, alt: "" }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: __webpack_require__(641), className: 'homeShells-homeShellClose', onClick: function () {
                            _this.clickMethods();
                        }, alt: "" }))));
    };
    Home.prototype.componentWillUnmount = function () {
        __WEBPACK_IMPORTED_MODULE_9__utils__["w" /* tingYun */].endTingYun();
    };
    Home.defaultProps = {
        prefixCls: 'home'
    };
    Home.contextTypes = {
        router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
    };
    __decorate([
        __WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]
    ], Home.prototype, "timeAxisList", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]
    ], Home.prototype, "timeCurrent", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_13_mobx__["observable"]
    ], Home.prototype, "htmlId", void 0);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onHomey", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "clickCloseAlert", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onEntryClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "renderContent", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onTimeAxisClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onSpecialClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onAddShop", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onBannerClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onFloorClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onChannelClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "renderItem", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "toApptaile", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onScroll", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "shopHomeJia", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "shopHomeJiaFunc", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "hideHomeJia", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "toOther", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "clickMethods", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "onSearchClick", null);
    __decorate([
        __WEBPACK_IMPORTED_MODULE_3_autobind_decorator___default.a
    ], Home.prototype, "showLoading", null);
    return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["inject"])('user', 'status')(Object(__WEBPACK_IMPORTED_MODULE_4_mobx_react__["observer"])(Home)));


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading.bff11410.gif";

/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/game_loading_bg.52e48c2a.png";

/***/ }),

/***/ 639:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(640);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(480)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-oneOf-3-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/less-loader/dist/cjs.js??ref--2-oneOf-3-4!./Home.less", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-oneOf-3-2!../../../../node_modules/postcss-loader/lib/index.js??postcss!../../../../node_modules/less-loader/dist/cjs.js??ref--2-oneOf-3-4!./Home.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(479)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes myanmtops{0%{top:-35px}to{top:0}}@keyframes myanmtops{0%{top:-35px}to{top:0}}.home{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.home .downwarp-progress{border:1px solid #fff!important}.home .downwarp-tip{color:#fff}.home .mescroll-downwarp .downwarp-content{color:#fff!important}.home .clearfix{background:#fff}.home::-webkit-scrollbar{display:none}.cookle_btn{position:fixed;left:50%;top:10%;z-index:100000;padding:20px;background:#fff}.home-topBox{position:fixed;height:4.8125rem;z-index:100;padding:.7rem 0}.home-search-background,.home-topBox{background:#fff;left:0;top:0;width:100%}.home-search-background{position:absolute;height:5rem;z-index:99}.home-floor{position:static;left:0;top:4.8125rem;width:100%;z-index:100}.loading1{width:100%;height:100%;position:fixed;left:0;top:0;z-index:99999;background:url(" + __webpack_require__(582) + ") no-repeat;background-size:100% 100%}.loading1 .process_view{width:29.5rem;opacity:.2}.loading1 .process_bar,.loading1 .process_view{height:3px;background:#fff;border-radius:1.5px;position:fixed;bottom:3.8rem;left:50%;margin-left:-14.75rem}.loading1 .process_bar{width:0}.loading1 .process_text{width:8rem;height:1.8rem;line-height:1.8rem;text-align:center;font-size:1rem;color:#fafafa;position:fixed;bottom:1.2rem;left:50%;margin-left:-4rem}.home-loading{width:100%;height:91vh;background:url(" + __webpack_require__(552) + ") no-repeat 50%;background-size:5.8rem 5.8rem}.homeShells{width:100%;height:100%}.homeShells-area-container{position:fixed;width:100%;height:100%;background:#000;opacity:.72;z-index:1000;top:0;left:0}.homeShells-img-area{position:fixed;top:6.7rem;left:3rem;width:31.5rem;height:45.4rem;z-index:1001}.homeShells-homeShellClose{position:fixed;width:2.7rem;height:2.7rem;top:5rem;right:1.3rem;z-index:1002}.floorModule-space{height:.8rem}#home-list:nth-child(2n){margin-right:.7rem;margin-left:.8rem}", "", {"version":3,"sources":["/root/.jenkins/workspace/new-h5-gyweb-app/src/pages/index/home/Home.less"],"names":[],"mappings":"AAAA,6BACE,GACE,SAAW,CACZ,AACD,GACE,KAAO,CACR,CACF,AACD,qBACE,GACE,SAAW,CACZ,AACD,GACE,KAAO,CACR,CACF,AACD,MACE,yBAA0B,AAC1B,sBAAuB,AACvB,qBAAsB,AACtB,gBAAkB,CACnB,AACD,yBACE,+BAAkC,CACnC,AACD,oBACE,UAAY,CACb,AACD,2CACE,oBAAuB,CACxB,AACD,gBACE,eAAiB,CAClB,AACD,yBACE,YAAc,CACf,AACD,YACE,eAAgB,AAChB,SAAU,AACV,QAAS,AACT,eAAgB,AAChB,aAAc,AACd,eAAiB,CAClB,AACD,aAEE,eAAgB,AAIhB,iBAAkB,AAClB,YAAa,AACb,eAAiB,CAClB,AACD,qCATE,gBAAoB,AAEpB,OAAQ,AACR,MAAO,AACP,UAAY,CAab,AARD,wBACE,kBAAmB,AAKnB,YAAa,AACb,UAAY,CACb,AACD,YACE,gBAAkB,AAClB,OAAQ,AACR,cAAe,AACf,WAAY,AACZ,WAAa,CACd,AACD,UACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,OAAQ,AACR,MAAO,AACP,cAAe,AACf,mDAAiE,AACjE,yBAA2B,CAC5B,AACD,wBACE,cAAe,AAEf,UAAa,CAOd,AACD,+CATE,WAAY,AAEZ,gBAAoB,AACpB,oBAAqB,AACrB,eAAgB,AAChB,cAAe,AACf,SAAU,AACV,qBAAuB,CAWxB,AATD,uBACE,OAAS,CAQV,AACD,wBACE,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,eAAgB,AAChB,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,cACE,WAAY,AACZ,YAAa,AACb,uDAAgE,AAChE,6BAA+B,CAChC,AACD,YACE,WAAY,AACZ,WAAa,CACd,AACD,2BACE,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,YAAc,AACd,aAAc,AACd,MAAO,AACP,MAAQ,CACT,AACD,qBACE,eAAgB,AAChB,WAAY,AACZ,UAAW,AACX,cAAe,AACf,eAAgB,AAChB,YAAc,CACf,AACD,2BACE,eAAgB,AAChB,aAAc,AACd,cAAe,AACf,SAAU,AACV,aAAc,AACd,YAAc,CACf,AACD,mBACE,YAAc,CACf,AACD,yBACE,mBAAqB,AACrB,iBAAoB,CACrB","file":"Home.less","sourcesContent":["@-webkit-keyframes myanmtops {\n  0% {\n    top: -35px;\n  }\n  100% {\n    top: 0;\n  }\n}\n@keyframes myanmtops {\n  0% {\n    top: -35px;\n  }\n  100% {\n    top: 0;\n  }\n}\n.home {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.home .downwarp-progress {\n  border: 1px solid #FFF !important;\n}\n.home .downwarp-tip {\n  color: #FFF;\n}\n.home .mescroll-downwarp .downwarp-content {\n  color: #FFF !important;\n}\n.home .clearfix {\n  background: #FFF;\n}\n.home::-webkit-scrollbar {\n  display: none;\n}\n.cookle_btn {\n  position: fixed;\n  left: 50%;\n  top: 10%;\n  z-index: 100000;\n  padding: 20px;\n  background: #fff;\n}\n.home-topBox {\n  background: #FFFFFF;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 4.8125rem;\n  z-index: 100;\n  padding: .7rem 0;\n}\n.home-search-background {\n  position: absolute;\n  background: #FFFFFF;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 5rem;\n  z-index: 99;\n}\n.home-floor {\n  position: initial;\n  left: 0;\n  top: 4.8125rem;\n  width: 100%;\n  z-index: 100;\n}\n.loading1 {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  left: 0;\n  top: 0;\n  z-index: 99999;\n  background: url(\"../../../images/game_loading_bg.png\") no-repeat;\n  background-size: 100% 100%;\n}\n.loading1 .process_view {\n  width: 29.5rem;\n  height: 3px;\n  opacity: 0.2;\n  background: #FFFFFF;\n  border-radius: 1.5px;\n  position: fixed;\n  bottom: 3.8rem;\n  left: 50%;\n  margin-left: -14.75rem;\n}\n.loading1 .process_bar {\n  width: 0;\n  height: 3px;\n  background: #FFFFFF;\n  border-radius: 1.5px;\n  position: fixed;\n  bottom: 3.8rem;\n  left: 50%;\n  margin-left: -14.75rem;\n}\n.loading1 .process_text {\n  width: 8rem;\n  height: 1.8rem;\n  line-height: 1.8rem;\n  text-align: center;\n  font-size: 1rem;\n  color: #FAFAFA;\n  position: fixed;\n  bottom: 1.2rem;\n  left: 50%;\n  margin-left: -4rem;\n}\n.home-loading {\n  width: 100%;\n  height: 91vh;\n  background: url('../../../images/loading.gif') no-repeat center;\n  background-size: 5.8rem 5.8rem;\n}\n.homeShells {\n  width: 100%;\n  height: 100%;\n}\n.homeShells-area-container {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  opacity: 0.72;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n}\n.homeShells-img-area {\n  position: fixed;\n  top: 6.7rem;\n  left: 3rem;\n  width: 31.5rem;\n  height: 45.4rem;\n  z-index: 1001;\n}\n.homeShells-homeShellClose {\n  position: fixed;\n  width: 2.7rem;\n  height: 2.7rem;\n  top: 5rem;\n  right: 1.3rem;\n  z-index: 1002;\n}\n.floorModule-space {\n  height: .8rem;\n}\n#home-list:nth-child(even) {\n  margin-right: 0.7rem;\n  margin-left: 0.8rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAGHRSTlMAsgaDpw1mjHhcSjlWm3GilEIwKBOITxoEywEoAAACVklEQVRYw82Z63LjIAyFsWqDAd/tJO//pgslDNksRL7smVZ/2rHxlyMhyyDEj1mz2tl0nZnt2vwXnpWqrl6sVtJeIj/0VGVt0o9zRDIqqWsHqbUc2qRaGTrudvd8/KaX7fXGtujb86e65pjKJ7K1lL1t2yf2gNql94/05oOSxoQxy17Pv2VMM6OC5unbmV0xWL2E2uwZamovduUH3itnQ7PTqcGPvnPDpJdpxW6zXqz8HCcfTrWJA7YpH1j6wPzyrh9MavIh+Co/1JZc4UPWfrrZiRPWlcXcGZ2M1mwOrD6e4qT5uK6ZlHM5r+gslJR7C5rcJNWbOG1bnZmsxem34oJZB1je5Pd8QPmw9vSeFHVzDdq4AHTvF4y4aCYKS0Incdmmv6SSEzpfh85OKiXhIcZXjfrXIKp8REmPo6TMdTmOmvJRVfH/h0ux3NTrKhS1XIGsdC4B3PVHfLhQucYqUHPMaizUTp1mzZagiZqYZah1WZREU76g/UsNzFKRJB/IiL+Vvi6RmruUs1t0WoZA8FSeKXR0QYXywlN5plhiUrnXaRM8dQ9TbO6lCvMU/rJUjhkUhplag2KeyjFjLNcw+a3YQ+WYMf1tqC2D4KmJydX/OVQBKXgqz4z5aUKB1oKj8syUqB0ECnEfMlGQlIIkP+Q1RRQUSOmDFGnI5wTy4UN8oiGLCciyB7FAgywlIYtexPIcspFAbHkgmzPENhKx4YVszRFNBES7A9GYQbSQIM0uRFsO0EBEtDoRTVlE+xjQ6Ea05AGHB7/hmIM9kPldR0cHDrnw9gfFGhoBvB0sswAAAABJRU5ErkJggg=="

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.a35886d7.chunk.js